import { ref } from 'vue'
import { useDisplay } from 'vuetify'

const isSidebarOpen = ref(false)
const rail = ref(false)
const forceExpanded = ref(false)

function useLayout() {
  const { mobile } = useDisplay()

  function toggleSidebar() {
    if (mobile.value) {
      isSidebarOpen.value = !isSidebarOpen.value
    } else {
      if (forceExpanded.value) {
        forceExpanded.value = false
        rail.value = true
      } else {
        forceExpanded.value = true
        rail.value = false
      }
    }
  }

  return {
    isSidebarOpen,
    rail,
    forceExpanded,
    toggleSidebar,
  }
}

export { useLayout }
